<template>
  <div class="tabletHistory">
    <ClearCanvasUI></ClearCanvasUI>
    <HistoryUI></HistoryUI>
  </div>
</template>

<script>
import ClearCanvasUI from "../ui/ClearCanvasUI";
import HistoryUI from "../ui/HistoryUI";

export default {
  name: "TabletHistoryUI.vue",
  components: {
    HistoryUI,
    ClearCanvasUI
  },
};
</script>

<style scoped lang="sass">
@import "../../sass/zindex"
@import "../../sass/common"
.tabletHistory
  @include flexCenter()
</style>
